<template>
    <div>
        <Loader :show="loading"></Loader>
        <template v-if="!loading">
            <Banner
                :banners="banners"
                show-overlay
            > </Banner>
            <Breadcrumb></Breadcrumb>
            <div class="info-wrapper default">
                <h2
                    class="title text-center"
                    v-text="detail.name"
                >柳川</h2>
                <div class="detail-wrapper">
                    <h3>認識{{ detail.name }}</h3>
                    <p
                        class="html-wrapper border-bottom pb-3"
                        v-html="detail.description"
                    >
                        柳川位於臺灣臺中盆地，屬於烏溪水系，為舊旱溪的支流，為台中市中心四河川之一（與綠川、梅川、麻園頭溪並列其名）。中正柳橋到南屯柳橋為「柳川汙染整治及環境改善工程」，施工期為2015年初到2016年年底，其中臺灣大道至民權路為生態工法的親水景觀段[1]。整體柳川整治分成三期，第一期自柳楊東西街至學士路，整治長度為3.7公里，於胡志強市長任內完成；第二期自學士路至民權路，整治1.7公里，於2021年1月啟用開放；第三期自民權路到南屯路，整治2公里，目前發包中。
                    </p>
                    <div
                        id="carouselDetail"
                        class="carousel slide"
                        data-ride="carousel"
                        v-show="
                            detail.listPhotos && detail.listPhotos.length > 0
                        "
                    >
                        <div class="carousel-inner">
                            <div
                                class="carousel-item"
                                v-for="(photoId, index) in detail.listPhotos"
                                :class="{ active: index === 0 }"
                                :key="photoId"
                            >
                                <vue-load-image>
                                    <img
                                        slot="image"
                                        :src="`${apiPhotoUrl}/ori/${photoId}`"
                                        :alt="detail.name + index"
                                        class="detail-img"
                                    />
                                    <img
                                        slot="preloader"
                                        src="@/assets/image-loader.gif"
                                        class="w-100"
                                    />
                                    <img
                                        slot="error"
                                        class="border d-block detail-img"
                                        src=""
                                        alt="not found"
                                    />
                                </vue-load-image>
                            </div>
                        </div>
                        <button
                            class="carousel-control-next"
                            type="button"
                            data-target="#carouselDetail"
                            data-slide="next"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 256 512"
                                style="fill:#73B3E2;width:1.277rem"
                            >
                                <path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z" />
                            </svg>
                            <span class="sr-only">Next</span>
                        </button>
                    </div>
                    <audio
                        controls
                        ref="audio"
                        class="d-none"
                    >
                        <source
                            :src="`${urls.audio}?id=${detail.id}&audioType=0`"
                            type="audio/mpeg"
                        />
                        Your browser does not support the audio element.
                    </audio>
                    <button
                        class="btn btn-more w-100 d-block my-3 audio-tour-btn"
                        @click="playAudio"
                    >
                        語音導覽
                        <div
                            class="overlay"
                            v-show="playing"
                        >
                            <!-- <i class="las la-pause"></i> -->

                            <div class="svg-wrapper">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 320 512"
                                    style="fill:#000;width:1.177rem;height:1.177rem;"
                                >
                                    <path d="M272 63.1l-32 0c-26.51 0-48 21.49-48 47.1v288c0 26.51 21.49 48 48 48L272 448c26.51 0 48-21.49 48-48v-288C320 85.49 298.5 63.1 272 63.1zM80 63.1l-32 0c-26.51 0-48 21.49-48 48v288C0 426.5 21.49 448 48 448l32 0c26.51 0 48-21.49 48-48v-288C128 85.49 106.5 63.1 80 63.1z" />
                                </svg>
                            </div>

                        </div>
                    </button>
                    <button
                        class="btn btn-more w-100 d-block my-3"
                        @click="goGoogleMap([detail.lon, detail.lat])"
                    >
                        如何抵達
                    </button>
                </div>

                <NearbyAttractions
                    :river-id="detail.id"
                    :origin="[detail.lon, detail.lat]"
                ></NearbyAttractions>
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';
import NearbyAttractions from '@/components/nearby/Attractions';
import Loader from '@/components/Loader';
import { apiRiverDetail } from '@/plugin/api';
import { GET_AUDIO } from '@/plugin/api/constants';

export default {
    data() {
        return {
            banners: [
                {
                    // eslint-disable-next-line global-require
                    linkUrl: require('@/assets/banner_guide.jpg'),
                },
            ],
            urls: {
                audio:
                    (process.env.NODE_ENV === 'development'
                        ? ''
                        : process.env.VUE_APP_API) + GET_AUDIO,
            },
            loading: false,
            detail: {},

            playing: false,
        };
    },
    mounted() {
        this.getDetail();
        this.initAudio();
    },
    computed: {
        ...mapState('userData', ['currentPosition']),
        ...mapGetters('userData', ['isInValidScope']),
    },
    methods: {
        ...mapActions('userData', ['setSpotPosition']),
        goView(link) {
            this.$router.push(link);
        },
        async getDetail() {
            const { id } = this.$route.params;
            this.loading = true;
            await apiRiverDetail(id).then((res) => {
                if (res.data.success) {
                    this.detail = {
                        ...res.data.data,
                        lat: +res.data.data.latitude,
                        lon: +res.data.data.longitude,
                        name: res.data.data.name,
                        id: res.data.data.riverId,
                    };
                    this.setSpotPosition([this.detail.lon, this.detail.lat]);
                    const { breadcrumb } = this.$route.meta;
                    breadcrumb[breadcrumb.length - 1].name = this.detail.name;
                    breadcrumb[breadcrumb.length - 1].link = breadcrumb[
                        breadcrumb.length - 1
                    ].link.replace(':id', this.detail.id);
                }
            }, this.errorHandler);
            this.loading = false;
        },
        initAudio() {
            this.$refs.audio.addEventListener('canplay', () => {
                if (this.$refs.audio) {
                    this.$refs.audio.removeEventListener(
                        'ended',
                        this.stopPlaying,
                    );
                    this.$refs.audio.addEventListener(
                        'ended',
                        this.stopPlaying,
                    );
                    this.$refs.audio.removeEventListener(
                        'paused',
                        this.stopPlaying,
                    );
                    this.$refs.audio.addEventListener(
                        'paused',
                        this.stopPlaying,
                    );
                }
            });
        },
        playAudio() {
            if (this.$refs.audio.paused) {
                this.$refs.audio.play();
                this.playing = true;
            } else {
                this.$refs.audio.pause();
                this.playing = false;
            }
        },
        stopPlaying() {
            this.playing = false;
        },
    },
    components: {
        Banner,
        Breadcrumb,
        Loader,
        NearbyAttractions,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
